import {debounce} from '../_functions'
import $ from 'jquery'
import {lockBody, unlockBody} from "../_utils";

document.addEventListener("DOMContentLoaded", function (dom) {
    const professionsList = dom.target.querySelectorAll('.feed-maritime-profession');
    const searchInput = dom.target.querySelector('.js-professions-search-input');
    const categorySelect = dom.target.querySelector('.js-professions-category');

    if (professionsList.length && searchInput) {
        const filterProfessions = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            professionsList.forEach(post => {
                const title = post.querySelector('.js-title');
                const titleText = title ? title.innerText.toLowerCase() : '';
                const titleData = post.dataset.title;
                const postTerms = JSON.parse(post.dataset.terms || '[]');

                var matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                if ( ! matchSearch ) {
                    matchSearch = searchTerm === '' || titleData.includes(searchTerm);
                }
                const matchCategory = categorySelect.value === '' || postTerms.includes(categorySelect.value);

                if (matchSearch && matchCategory) {
                    post.classList.remove('hidden');
                } else {
                    post.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterProfessions, 300);
        searchInput.addEventListener('input', handleInput);

        categorySelect.addEventListener('change', filterProfessions);

        filterProfessions();
    }
});